<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >
    <template v-slot:activator="{ props }">
      <slot name="activator" v-bind="{ props }" />
    </template>

    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span>{{ $t('routes.pod.menuSetThumbnail.setFrameAsThumb') }}</span>
        <v-btn icon @click="dialog = false" :aria-label="$t('common.close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="scrollable mt-4">
        <v-form ref="form" data-cy="podMenu-tools-setFrameAsThumbnail-form">
          <div class="mb-4 d-flex">
            <div class="text-right d-flex align-center" style="width: 20%;">
              {{ $t('routes.pod.menuSaveFrame.time') }}
            </div>

            <div style="width: 45%;">
              <v-text-field
                v-bind:model-value="playerTimeFormatted"
                v-bind:placeholder="$t('routes.pod.menuSaveFrame.time')"
                variant="solo-filled"
                hide-details="auto"
                readonly disabled flat
                data-cy="podMenu-tools-setFrameAsThumbnail-playerTime"
              />
            </div>
          </div>

          <div v-show="successMessage" class="bg-success"
               data-cy="podMenu-tools-setFrameAsThumbnail-successMessage">{{ successMessage }}
          </div>
          <div v-show="errorMessage" class="bg-error"
               data-cy="podMenu-tools-setFrameAsThumbnail-errorMessage">{{ errorMessage }}
          </div>
          <UtilityPodsErrors
            data-cy="podMenu-tools-setFrameAsThumbnail-utilityPodsError"></UtilityPodsErrors>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-on:click.prevent="setThumbnail"
          v-bind:disabled="isSubmitDisabled"
          color="primary"
          variant="flat"
          data-cy="podMenu-tools-setFrameAsThumbnail-setThumbnail-btn"
        >
          {{ $t('routes.pod.menuSetThumbnail.setThumbnail') }}
        </v-btn>

        <v-btn variant="text" @click="dialog = false">{{ $t('common.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { usePlayerStore } from '@/stores/PlayerStore.js'
import { useServiceStore } from '@/stores/ServiceStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import { toTimeMilliseconds, toTimeMillisecondsFull } from '@/components/formatters.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [DialogActionKeys, DialogModel],
  name: "SetFrameAsThumbnailDialog",
  props: {
    pod: {
      type: Object,
      required: false
    },
  },
  data() {
    return {
      preventDoubleClick: false,
      successMessage: "",
      errorMessage: "",
    };
  },
  watch: {
    dialog: {
      handler: function (val) {
        if (!val) {
          this.successMessage = "";
          this.errorMessage = "";
        }
      }
    }
  },
  methods: {
    updatePodsUtility: function() {
      if (!this.getUpdateThumbnail) {
        this.errorMessage = "Update-thumbnail service not found!";
        return;
      }

      let utilityPayload = {
        serviceAlias: this.getUpdateThumbnail.alias,
        pods: [this.pod],
      }

      const serviceStore = useServiceStore();
      return serviceStore.updatePodsUtility(utilityPayload);
    },
    setThumbnail: function() {
      this.errorMessage = "";
      this.successMessage = "";

      let self = this;

      this.preventDoubleClick = true;
      setTimeout(() => {
        self.preventDoubleClick = false;
      }, 10000);

      this.updatePodsUtility()
      .then(function() {

        const serviceStore = useServiceStore();
        const runnable = serviceStore.getRunnablePods;

        if (runnable.length == 0) {
          throw { response: { data: { error: { message: self.$t("routes.pod.menuSetThumbnail.operationError")}}}}
        }

        let payload = {
          serviceAlias: self.getUpdateThumbnail.alias,
          utilityPods: runnable,
          params: {
            startTime: self.playerTimeMilliseconds,
          }
        }

        return serviceStore.runService(payload)
      })
      .then(function() {
        if (self.utilityPodsErrors.length == 0) {
          self.successMessage = self.$t("routes.pod.menuSetThumbnail.operationQueued");
        }
      })
      .catch(function(error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          self.errorMessage = error.response.data.error.message;
        } else {
          self.errorMessage = "Error!";
          console.log(error);   // unhandled error
        }
      })
      .finally(function () {
        self.preventDoubleClick = false;
      });
    },
  },
  computed: {
    playerCURRENTTIME: function() {
      const playerStore = usePlayerStore();
      return playerStore.currentTime;
    },
    playerTimeFormatted: function() {
      return toTimeMilliseconds(this.playerCURRENTTIME)
    },
    playerTimeMilliseconds: function() {
      return toTimeMillisecondsFull(this.playerCURRENTTIME);
    },
    getUpdateThumbnail: function() {
      const serviceStore = useServiceStore();
      return serviceStore.getUpdateThumbnail;
    },
    utilityPodsErrors: function() {
      const serviceStore = useServiceStore();
      return serviceStore.getUtilityPodsErrors;
    },
    isSubmitDisabled: function() {
      return this.utilityPodsErrors.length > 0 || this.preventDoubleClick || this.successMessage.length > 0;
    },
  }
}
</script>

<style>
</style>
